import adminData from '../data/admin-data.json';
import PortalHeader from '../components/PortalHeader';
import PageHeader from '../components/PageHeader';

const products = adminData.products || [];

export default function Products() {
  return (
    <>
      <PortalHeader />
      <div className="page">
        <PageHeader backTo="/admin" backLabel="Admin" title="Products &amp; Entitlements" />

        {products.length === 0 ? (
          <p className="empty-state">No products configured.</p>
        ) : (
          <table className="config-table">
            <thead>
              <tr>
                <th>Product</th>
                <th>Type</th>
                <th>Price (EUR)</th>
                <th>Entitlements Granted</th>
              </tr>
            </thead>
            <tbody>
              {products.map((p) => (
                <tr key={p.id}>
                  <td>
                    <code>{p.id}</code>
                    <br />
                    <span style={{ fontSize: '0.8rem', color: '#666' }}>
                      {p.display_name}
                    </span>
                  </td>
                  <td>{p.type.replace(/_/g, ' ')}</td>
                  <td>
                    {p.pricing && p.pricing.EUR
                      ? `\u20AC${p.pricing.EUR}`
                      : '\u2014'}
                  </td>
                  <td>
                    {p.entitlements.map((e) => (
                      <code key={e} style={{ marginRight: '0.35rem' }}>
                        {e}
                      </code>
                    ))}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
}
